


















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {MAX_CHAR, WARNING_LENGTH} from "@/constants/orders";
import { namespace } from 'vuex-class';
import HubSelector from "@/views/components/FormInputs/HubSelector.vue";
import {debounce} from "lodash";
import {stripHtmlTags} from "@/helpers/stringHelpers";


const userDataModule = namespace("userData");
const EMPTY_STRING = '';

@Component({
  name: 'TextAreaInput',
  components: {
    HubSelector,
  },
})
export default class TextAreaInput extends Vue {
  private notes: string = '';
  private stringCounter: number = 0;
  private readonly MAX_CHAR: number = MAX_CHAR;
  private readonly WARNING_LENGTH: number = WARNING_LENGTH;

  @Prop({ default: EMPTY_STRING})
  private value!: string;

  @Prop({ default: EMPTY_STRING})
  private placeHolder!: string;

  @Watch('notes')
  private onNotesChange(val: string) {
    this.stringCounter = val.length;
  }

  private get getPlaceHolder() {
    return this.placeHolder === EMPTY_STRING ? this.$t('shipmentNotes.placeholder')
                                             : this.placeHolder;
  }

  private handleChangeDebounced: () => void = () => true;

  private mounted() {
    this.notes = this.value;
    this.handleChangeDebounced = debounce(
        () => this.handleChange(),
        200,
        {leading: false, trailing: true});
  }

  private sanitizeInputs() {
    this.notes = stripHtmlTags(this.notes);
  }

  private handleChange() {
    this.$emit('input', this.notes);
  }
}
